module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-glitter_trimmark.c8d0d9e8.png";